import styled, { css } from 'styled-components';
import { colors, toRgba, breakPoints, mixins } from '@/styles';

export const QueryTools = styled.div<{ $isOpen: boolean }>`
  position: relative;
  overflow: hidden;
  max-height: ${({ $isOpen }) => ($isOpen ? '500px' : '0')};
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
  transition: max-height 0.3s ease-out;
`;

export const QuerySummary = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  background: ${colors.secondary.lightGray1};
`;

export const QueryHeader = styled.div`
  .toggle {
    display: flex;
    align-items: center;
    gap: 2px;
    cursor: pointer;
    color: ${colors.semantic.link};
    text-decoration: underline;
  }
`;

export const QueryContext = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 5px 10px;
  /* background-color: ${colors.primary.white}; */
`;

export const QueryInputWrapper = styled.div`
  ${mixins.gradientBorder({})};
  margin: 5px;
  padding: 1px;
  & > * {
    border-radius: 5px;
  }
`;

export const QueryInput = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;

  &:focus-within {
    box-shadow: ${toRgba(colors.semantic.link, 0.15)} 0px 0px 1px 1px inset;
  }
  padding: 5px;
  background-color: ${colors.primary.white};
  & > svg {
    margin: 5px;
    height: 18px;
    width: 18px;
  }
  & > input {
    flex: 1;
    outline: none;
    border: none;
    width: 100%;
    height: 100%;
    ${mixins.avoidAutofillHighlight};
    &:disabled {
      background-color: transparent;
    }
  }
`;
